import menuAvatar from './menuAvatar.reducer';

export default menuAvatar;
